import { cssVar, HStack, Button, IconButton, Text } from '@cad-arc';
import { FR_HEADER_HEIGHT } from '../constants';

interface FrSearchPageHeaderProps {
    text: string;
    resultsOrSavedShown: boolean;
    showSavedSearches: boolean;
    openSavedSearch: () => void;
    closeSearches: () => void;
}

export function PageHeader({
    text,
    resultsOrSavedShown,
    openSavedSearch,
    showSavedSearches,
    closeSearches,
}: FrSearchPageHeaderProps) {
    return (
        <HStack
            w="100%"
            minH={`${FR_HEADER_HEIGHT}px`}
            borderBottomWidth="1px"
            borderBottomColor="border.default"
            alignItems="center"
            px="16px"
            flexShrink={0}
            justifyContent="space-between"
            backgroundColor={cssVar('arc.colors.surface.foreground')}
        >
            <HStack>
                {resultsOrSavedShown && (
                    <IconButton
                        icon="ArrowLeft"
                        onClick={closeSearches}
                        aria-lebel="back to search form"
                        variant="ghost"
                    />
                )}
                <Text variant="headingLg">{text}</Text>
            </HStack>
            {!showSavedSearches && (
                <Button variant="outline" onClick={openSavedSearch}>
                    Saved Searches
                </Button>
            )}
        </HStack>
    );
}
